/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingListTransactionRequest {
    getFixupPrototypeFunction() { return MasterAccountBillingListTransactionRequest.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingListTransactionRequest>): MasterAccountBillingListTransactionRequest {
        let obj = Object.assign(new MasterAccountBillingListTransactionRequest(), model);
        MasterAccountBillingListTransactionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingListTransactionRequest>): MasterAccountBillingListTransactionRequest {
        if (!model) return null;
        return MasterAccountBillingListTransactionRequest.newInstance(<MasterAccountBillingListTransactionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingListTransactionRequest) {
        if (!obj) return;

        models.MasterAccountBillingListTransactionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingListTransactionRequest): boolean {
        Object.setPrototypeOf(obj, MasterAccountBillingListTransactionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.MasterAccountBillingTransactionRequestContext.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.MasterAccountBillingListTransactionsSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.MasterAccountBillingListTransactionsSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.MasterAccountBillingTransactionRequestContext;

}
